export default __webpack_public_path__ + "static/media/brown burger.8d69b303.png";